<template>
  <div class="home-page">
    <div class="sidebar-section" :class="{ 'sidebar-hidden': isSidebarCollapsed }">
      <sidebar @sidebar-toggle="handleSidebarToggle" @new-chat="handleNewChat" />
    </div>
    <div class="content-section" :class="{ 'content-full-width': isSidebarCollapsed }" :style="contentStyle">
      <main-content ref="mainContent" />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/sidebar/Sidebar.vue';
import MainContent from '@/components/home/MainContent.vue';
import { authClient, getLoginUrl } from '@/utils/auth-client.js';

export default {
  name: 'HomePage',
  components: {
    Sidebar: Sidebar,
    MainContent
  },
  data() {
    return {
      isSidebarCollapsed: false,
      sidebarWidth: 318, // 侧边栏展开时的宽度
    };
  },
  computed: {
    contentStyle() {
      if (this.isSidebarCollapsed) {
        return {
          marginLeft: '0px',
          width: '100%',
          transition: 'margin-left 0.3s, width 0.3s'
        };
      } else {
        return {
          marginLeft: `${this.sidebarWidth}px`,
          width: `calc(100% - ${this.sidebarWidth}px)`,
          transition: 'margin-left 0.3s, width 0.3s'
        };
      }
    },
    // 使用Better Auth的session - 修改以处理新的数据结构
    session() {
      try {
        const sessionHook = authClient.useSession();
        console.log(sessionHook.value);
        
        if (sessionHook.value) {
          return sessionHook.value;
        }
        
        return null;
      } catch (error) {
        console.error('HomePage获取session失败:', error);
        return null;
      }
    },
    isPending() {
      try {
        const sessionHook = authClient.useSession();
        return sessionHook.value?.isPending || false;
      } catch (error) {
        return false;
      }
    },
    // 添加用户信息计算属性
    currentUser() {
      console.log(this.session);
      if (this.session.data?.user) {
        return this.session.data.user;
      }
      return null;
    }
  },
  methods: {
    handleSidebarToggle(collapsed) {
      this.isSidebarCollapsed = collapsed;
    },
    handleNewChat() {
      // 获取MainContent组件的引用
      const mainContent = this.$refs.mainContent;
      if (mainContent && mainContent.$refs.chatInterface) {
        // 如果MainContent有ChatInterface引用，则调用其清空对话方法
        mainContent.$refs.chatInterface.clearInput();
      }
    },
    handleCottonClick() {
      // 触发棉花炭疽病信息展示
      this.$root.$emit('cottonClicked');
    },
    checkAuthentication() {
      // 检查认证状态
      const urlParams = new URLSearchParams(window.location.search);
      const isAuthCallback = urlParams.has('auth');
      
      console.log('HomePage 检查认证状态:', {
        hasUser: !!this.currentUser,
        isAuthCallback,
        isPending: this.isPending,
        url: window.location.href
      });
      
      // 如果已经有用户信息，不需要跳转
      if (this.currentUser) {
        console.log('HomePage: 用户已登录，无需跳转');
        return;
      }
      
      // 如果没有session且不是认证回调页面且不在加载中，则跳转到登录
      if (!this.currentUser && !isAuthCallback && !this.isPending) {
        console.log('HomePage: 用户未登录，跳转到登录页面');
        window.location.href = getLoginUrl();
      }
    }
  },
  mounted() {
    console.log('HomePage mounted');
    
    // 延迟检查认证状态，让Better Auth初始化完成
    setTimeout(() => {
      this.checkAuthentication();
    }, 300);
    
    // 初始化页面功能
    this.$root.$on('cottonImageClicked', this.handleCottonClick);
  },
  beforeDestroy() {
    this.$root.$off('cottonImageClicked', this.handleCottonClick);
  }
}
</script>

<style scoped>
.home-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #f5f5f5;
}

.sidebar-section {
  position: fixed;
  height: 100vh;
  z-index: 10;
  transition: width 0.3s;
  width: 318px;
}

.sidebar-hidden {
  width: 0;
}

.content-section {
  position: relative;
  height: 100vh;
  overflow-y: auto;
  background-color: #f9f9f9;
}

.content-full-width {
  margin-left: 0 !important;
  width: 100% !important;
}
</style>
